import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Get the pfe page ID from any ActivatedRouteSnapshot. This can be from the root
 * or anywhere lower in the tree.
 */
export function getPageIDFromRouteSnapshot(snapshot: ActivatedRouteSnapshot): string | undefined {
  // Check if we found the pfe page in the routing config.
  // The pfePage boolean flag is created by the pfe during the routing setup
  // and can be used to identify a pfe page.
  // The path corresponds to the pageID and is also set by the pfe during the
  // routing setup.
  // Checking for the pfe flag, also ensures that other router outlets are ignored
  if (
    (snapshot?.data?.pfePage === true || //
      snapshot?.routeConfig?.data?.pfePage === true) &&
    snapshot?.routeConfig?.path
  ) {
    return snapshot.routeConfig.path;
  } else {
    for (const child of snapshot.children) {
      const pageID = getPageIDFromRouteSnapshot(child);
      if (pageID) {
        return pageID;
      }
    }
  }
}
